<template>
  <div>
    <TitlePage :title="$t('report')"></TitlePage>
    <v-container fluid>
      <div class="dashboard-page">
        <v-row>
          <v-col md="10" xs="12">
            <v-chip color="primary" label small text-color="white">Promo Super Admin</v-chip> <a href="/#/report-promo-superadmin">(Switch Global Version)</a>
          </v-col>
          <v-col cols="12" md="12">
            <v-card elevation="2">
              <v-card>
                <v-card-title>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Filtra nella tabella" single-line hide-details dense/>
                </v-card-title>
                <v-data-table :headers="headers" :items="list" :search="search" :items-per-page="-1" :item-class="row_classes">
                  <template v-slot:item.center_name="{ item }">
                    <span class="font-weight-bold">{{item.center_name}}</span>
                  </template>
                  <template v-slot:item.promo_sa_active="{ item }">
                    <v-chip v-if="item.promo_sa_active" color="green" dark small label>
                      ATTIVA
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_active === false && item.promo_sa_sold === true" color="primary" dark small label>
                      TERMINATA
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_active === false" color="red" dark small label>
                      SCADUTA
                    </v-chip>
                  </template>

                  <template v-slot:item.promo_sa_sold="{ item }">
                    <v-chip v-if="item.promo_sa_sold" color="green" dark small label >
                      VENDUTA
                    </v-chip>
                    <v-chip v-else-if="item.promo_sa_active === false" color="warning" dark small label>
                      INVENDUTA
                    </v-chip>
                  </template>

                  <template v-slot:item.date_next_promo_sa="{ item }">
                    <v-chip v-if="item.date_next_promo_sa" color="primary" dark small label outlined>
                      {{ item.date_next_promo_sa }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="ma-5"></v-divider>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitlePage from "../utils/TitlePage";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "ReportPromoSA",
  components: {TitlePage,CenterAutocomplete},
  data() {
    return {
      list:[],
      search: '',
      headers: [
        { text: 'Centro Sportivo', value: 'center_name'},
        { text: 'Campo', value: 'field_name' },
        { text: 'Status', value: 'promo_sa_active' },
        { text: 'Slot', value: 'scheduled' },
        { text: 'Inserita', value: 'created_at', width:20 },
        { text: 'GG Invenduta', value: 'days_unsold' },
        { text: 'Vendita', value: 'promo_sa_sold' },
        { text: 'Data Vendita', value: 'date_sold' },
        { text: 'Prox. Promo SA', value: 'date_next_promo_sa'},
        // { text: 'N° Promo SA', value: 'count_promo'},
      ],
    };
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getPromoSuperAdminStats': 'stats/getPromoSuperAdminStatsLegacy',
    }),


    goToHandler(section) {
      switch (section) {
        case "centers":
          this.$router.push('/centers/');
          break
        case "fields":
          this.$router.push('/fields/');
          break
      }
    },


    formatDate(date) {
      return date.getFullYear()+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+('0' + date.getDate()).slice(-2)
    },

    formatDateHuman(my_date) {
      if(my_date){
        var date = new Date(my_date)
        return ('0' + date.getDate()).slice(-2)+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+date.getFullYear()
      }else {
        return ''
      }

    },

    async makeSearch(){

      this.setLoading(true);
      var results = await this.getPromoSuperAdminStats({});

      var now = new Date()
      var i = 0

      results.result.map((center) => {

        var color = (i % 2 == 0) ? '':'grey-row'
        i++

        center.center_fields.map((field) => {

          var obj = {
            center_name: center.center_name,
            center_id: center.center_id,
            field_name: field.name,
            ready: false,
            color: color
          }

          if(field.promo.length > 0){

            var promo_date = new Date(field.promo[0].date)
            var created_at_date = new Date(field.promo[0].created_at)

            var split = field.promo[0].slot_id.split(';')
            var scheduled = split[0]+'/'+split[1]+'/'+split[2]+' | '+split[3]+' - '+split[4]

            if(field.promo[0].booking_id == null && now < promo_date){

              let diffTime = Math.abs(now.valueOf() - created_at_date.valueOf());
              let days = diffTime / (24*60*60*1000);
              let hours = (days % 1) * 24;
              let minutes = (hours % 1) * 60;

              obj.promo_sa_active = true
              obj.scheduled = scheduled
              obj.created_at = created_at_date.toLocaleString()
              obj.days_unsold = days.toFixed(2)+' GG'
              obj.promo_sa_sold = null
              obj.date_sold = null
              obj.date_next_promo_sa = null
              obj.count_promo = field.promo_count

            }else if(field.promo[0].booking_id == null && now > promo_date) {

              let diffTime = Math.abs(promo_date.valueOf() - created_at_date.valueOf());
              let days = diffTime / (24*60*60*1000);
              let hours = (days % 1) * 24;
              let minutes = (hours % 1) * 60;

              obj.promo_sa_active = false
              obj.scheduled = scheduled
              obj.created_at = created_at_date.toLocaleString()
              obj.days_unsold = days.toFixed(2)+' GG'
              obj.promo_sa_sold = false
              obj.date_sold = null
              obj.date_next_promo_sa = null
              obj.count_promo = field.promo_count

            }else {

              var updated_at_date = new Date(field.promo[0].updated_at)
              var next_date = new Date(field.promo[0].updated_at)
              next_date.setDate(next_date.getDate() + 30);

              let diffTime = Math.abs(promo_date.valueOf() - created_at_date.valueOf());
              let days = diffTime / (24*60*60*1000);
              let hours = (days % 1) * 24;
              let minutes = (hours % 1) * 60;

              obj.promo_sa_active = false
              obj.scheduled = scheduled
              obj.created_at = created_at_date.toLocaleString()
              obj.days_unsold = days.toFixed(2)+' GG'
              obj.promo_sa_sold = true
              obj.date_sold = updated_at_date.toLocaleString()
              obj.date_next_promo_sa = next_date.toLocaleDateString()
              obj.count_promo = field.promo_count

              if(next_date <= now){
                obj.ready = true
              }

            }

          }else {
            obj.promo_sa_active = null
            obj.scheduled = null
            obj.created_at = null
            obj.days_unsold = null
            obj.promo_sa_sold = null
            obj.date_sold = null
            obj.date_next_promo_sa = null
            obj.count_promo = null
          }

          this.list.push(obj)

        })

      })

      this.setLoading(false);
    },
    row_classes(item) {
      return item.color
    }
  },
  mounted() {

  },
  computed: {
    dateRangeText () {
      return this.formatDateHuman(this.period[0])+' ~ '+this.formatDateHuman(this.period[1])
    },
  },
  async created() {
    this.setLoading(true);
    await this.makeSearch()
    this.setLoading(false);
  },


}
</script>

<style>
.grey-row{
  background-color: #f1f1f1 !important
}
</style>